import { FilterGroup } from '@/components/filters/filter-button';
import { HStack } from '@chakra-ui/react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { SearchInput } from '@/components/ui/search-input';
import { AffiliateStatusFilter } from './AffiliatesStatusFilter';
import { AffiliatesDateFilter } from './AffiliatesDateFilter';
import type { AffiliateTableDateFilterType, DashboardTableDateFilter } from '@fluenceur/types';
import type { AffiliateFilters } from '@/types/filters';

interface AffiliatesFilterProps {
  search: string;
  status: AffiliateFilters['status'];
  dateFilter: DashboardTableDateFilter<AffiliateTableDateFilterType>;
  onSearchChange: (search: string) => void;
  onStatusChange: (status: AffiliateFilters['status']) => void;
  onDateFilterChange: (dateFilter: DashboardTableDateFilter<AffiliateTableDateFilterType>) => void;
  onDateFilterClear: () => void;
}

const AffiliatesFilter: React.FC<AffiliatesFilterProps> = ({
  search,
  status,
  dateFilter,
  onSearchChange,
  onStatusChange,
  onDateFilterChange,
  onDateFilterClear,
}) => {
  const { t } = useTranslation();

  const handleSearchChange = useCallback(
    (newSearch: string | undefined) => {
      onSearchChange(newSearch || '');
    },
    [onSearchChange]
  );

  const handleStatusChange = useCallback(
    (newStatus: 'active' | 'inactive' | 'all' | undefined) => {
      onStatusChange(newStatus || 'all');
    },
    [onStatusChange]
  );

  return (
    <FilterGroup>
      <HStack gap={2} width="100%" wrap="wrap" align="center">
        <SearchInput
          value={search}
          onChange={handleSearchChange}
          placeholder={t('affiliates.filters.search')}
          maxWidth="300px"
          size="sm"
        />
        <AffiliateStatusFilter
          value={status as 'active' | 'inactive' | 'all'}
          onChange={handleStatusChange}
        />
        <AffiliatesDateFilter
          value={dateFilter}
          onChange={onDateFilterChange}
          onClear={onDateFilterClear}
        />
      </HStack>
    </FilterGroup>
  );
};

export default AffiliatesFilter;
